import { BusinessArea, isSameBusinessArea } from '../../../../../../Enums/BusinessArea';
import { getBusinessAreaByChannel } from '../../../../../../Helpers/AgentHelper';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';

export const isChanelSameBusinessArea = (channel, businessArea) => {
  return isSameBusinessArea(getBusinessAreaByChannel(channel), businessArea);
};

export const mapCostCenterData = (costCenter, region, channel) => {
  return {
    id: costCenter.id,
    regionId: region.id,
    channelId: channel.id,
    key: `${costCenter.id}${costCenter.code}`,
    displayNames: [getCostCenterDisplayName(costCenter), getRegionDisplayName(region), getChannelDisplayName(channel)],
  };
};

export const mapRegionData = (region, channel) => {
  return {
    id: region.id,
    channelId: channel.id,
    key: `${region.id}${region.code}`,
    displayNames: [getRegionDisplayName(region), getChannelDisplayName(channel)],
  };
};

export const mapChanneldata = channel => {
  return {
    id: channel.id,
    key: `${channel.id}${channel.generalLedgerCostCenterCode}`,
    displayNames: [getChannelDisplayName(channel)],
  };
};

export const getCostCenterById = (id, list) => {
  return list.find(costCenter => costCenter.id === id);
};

export const getChannelById = (id, list) => {
  return list.find(channel => channel.id === id);
};

export const getRegionById = (id, list) => {
  return list.find(region => region.id === id);
};

export const getCostCenters = (list, selectedRegionId, selectedChannelId) => {
  if (selectedRegionId) {
    return list?.filter(x => x.regionId === selectedRegionId);
  }

  if (selectedChannelId) {
    return list?.filter(x => x.channelId === selectedChannelId);
  }

  return list;
};

export const getRegions = (list, selectedChannelId) => {
  if (selectedChannelId) {
    return list?.filter(x => x.channelId === selectedChannelId);
  }

  return list;
};

export const getOptionsForBusinessArea = () => {
  return [
    {
      key: BusinessArea.Private,
      value: BusinessArea.Private,
      displayName: formatMessage(Messages.customHeader_settings_private),
    },
    {
      key: BusinessArea.Commercial,
      value: BusinessArea.Commercial,
      displayName: formatMessage(Messages.customHeader_settings_commercial),
    },
  ];
};

const getChannelDisplayName = channel => {
  return `${channel.name} (${channel.generalLedgerCostCenterCode})`;
};

const getRegionDisplayName = region => {
  return `${region.name} (${region.code})`;
};

const getCostCenterDisplayName = costCenter => {
  return `${costCenter.name} (${costCenter.code})`;
};
